import axios from 'axios';
import { getHeaders, qs } from '@/admin/services/api/http-utils-helpers';
/*
 * Wraps axios and provides
 * more convenient post method
 * calls with payload data
 */
axios.defaults.baseURL = process.env.VUE_APP_API_HOST;

export function post(uri, data) {
  return axios.post(uri, data, {
    // headers: getHeaders(),
    // withCredentials: true,
  });
}

/*
 * Wraps axios and provides
 * more convenient put method
 * calls with data
 */
export function put(uri, data) {
  return axios.put(uri, data, {
    // headers: getHeaders(),
    // withCredentials: true,
  });
}

/*
 * Wraps axios and provides
 * more convenient delete method
 */
export function remove(uri) {
  return axios.delete(uri, {
    // headers: getHeaders(),
    // withCredentials: true,
  });
}

/*
 * Wraps axios and provides
 * more convenient get method
 * calls with data.
 */
export function get(uri, data = {}) {
  let url = uri;

  if (Object.keys(data).length > 0) {
    url = `${uri}?${qs(data)}`;
  }

  return axios.get(url, {
    // headers: {
    //   'x-firephp-version': 0.4
    // }
    // headers: getHeaders(),
    // withCredentials: true,
  });
}

export function upload(uri, data) {
  return fetch(uri, {
    // headers: getHeaders(true),
    cors: true,
    method: 'POST',
    body: data,
  });
}
